import { useSetDocumentTitle } from 'hooks/useSetDocumentTitle';
import { searchFacetsVolop } from 'modules/search/constants/searchFacetsVolop';
import { SearchPage } from 'modules/search/pages/Search/SearchPage';

export function SearchVolopsPage() {
  useSetDocumentTitle(
    /* TRANSLATORS: volop search page title */
    getText(
      'Best Virtual Volunteer Opportunities, On-Site Volunteering, and More',
    ),
  );

  return <SearchPage searchType="VOLOP" searchFacets={searchFacetsVolop} />;
}
